import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import OkTableConfigType from '@/@okmenu/components/tables/ok-table/OkTableConfigType'
import { API_URL, SERVER_TIMEZONE } from '@/constants/config'
import store from '@/store'

dayjs.extend(timezone)
const currentTimezone = dayjs.tz.guess()
const today = dayjs()

const QueuesTableConfig: OkTableConfigType = {
  mode: 'remote',
  url: `${API_URL}/queues`,
  socketPath: '/queues',
  socketAction: 'queues',
  rowsPath: 'data.queues',
  paginationPath: 'data.',
  rowClickable: false,
  attachBranchId: false,
  enableIntervalFetch: false,
  columns: [
    {
      label: 'fields.name',
      field: 'name',
    },
    {
      label: 'fields.phone',
      field: 'phone',
      tdClass: 'dir-ltr',
    },
    {
      label: 'queues.num-of-people',
      field: 'count',
    },
    {
      label: 'queues.table',
      field: 'table',
    },
    {
      label: 'queues.note',
      field: 'note',
    },
    {
      label: 'queues.status',
      field: 'status',
    },
    {
      label: 'queues.created-at',
      field: 'added_at',
      tdClass: 'dir-ltr',
      formatFn: (val: string) => {
        const time = dayjs.tz(val, 'DD/MM/YYYY h:mm A', SERVER_TIMEZONE).tz(currentTimezone)
        const sameDay = today.isSame(time, 'day')
        return time.format(sameDay ? 'hh:mm A' : 'DD/MM/YYYY hh:mm A')
      },
    },
    {
      label: 'forms.actions',
      field: 'actions',
    },
  ],
  paginationOptions: {
    enabled: true,
  },
  sortOptions: {
    enabled: false,
  },
  actions: [
  ],
  filters: [
    {
      label: 'fields.name',
      query: 'name',
      colLength: 3,
    },
    {
      label: 'fields.phone',
      query: 'phone',
      colLength: 3,
    },
    {
      label: 'queues.table',
      query: 'table',
      colLength: 3,
      type: 'select',
      multiple: true,
      options: store.getters['queues/tables'],
      optionsLabel: { keyLabel: 'name', valueLabel: 'id', translate: false },
    },
    {
      label: 'queues.num-of-people',
      preLabel: '#',
      query: 'num',
      colLength: 3,
    },
    {
      label: 'queues.note',
      query: 'note',
      colLength: 3,
    },
    {
      label: 'queues.status',
      query: 'status',
      colLength: 3,
      type: 'select',
      multiple: true,
      options: [{ name: 'queues.pending', value: 0 }, { name: 'queues.completed', value: 1 }, { name: 'queues.cancelled', value: 2 }],
      optionsLabel: { keyLabel: 'name', valueLabel: 'value', translate: true },
    },
    {
      label: 'queues.created-at',
      query: 'created_at',
      colLength: 3,
      type: 'date',
    },
  ],
}

export default QueuesTableConfig
